import {
  OrderRulesCreateRequestType,
  OrderRulesCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderRulesCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderRulesCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `order-rules`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as OrderRulesCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderRules],
      });
    },
  });
};
